import { Component, OnInit } from '@angular/core';
import {ToolbarService, TranslateService} from 'bos-commons';
import {RestService} from '../../shared/rest/rest.service';
import {SessionCounter} from './session-counter';
import {SessionCounterDto} from './session-counter-dto';
import {ArrayDataSource} from '@angular/cdk/collections';
import {TitleComponent} from '../title-component';

@Component({
  selector: 'app-logged-users',
  templateUrl: './logged-users.component.html',
  styleUrls: ['./logged-users.component.scss']
})
export class LoggedUsersComponent extends TitleComponent {

  sessionCounter: SessionCounter;

  displayedColumns = ['user', 'count'];

  constructor(private restService: RestService,
              private translate: TranslateService,
              toolbarService: ToolbarService) {
    super(toolbarService, translate);
  }
  data: ArrayDataSource<SessionCounterDto>;

  getTitleKey() {
    return  'admin.sessions';
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initialize();
  }

  private initialize() {
    this.restService.getSessionCounter().subscribe(sc => {
      this.sessionCounter = sc;

      const sessionCounterDto: SessionCounterDto [] = [];
      this.sessionsPerUserMap(this.sessionCounter).forEach((v, k) => {
        sessionCounterDto.push(new SessionCounterDto(k, v));
      });
      sessionCounterDto.push(new SessionCounterDto(this.translate.translateWithArgs('Session.summary'), this.sessionCounter.sessionCounter))
      this.data = new ArrayDataSource<SessionCounterDto>(sessionCounterDto);
    })
  }

  private sessionsPerUserMap(sessionCounter: SessionCounter): Map<string, number> {
    const map = new Map<string, number>();
    for (const value in sessionCounter.sessionsPerUser) {
      if (sessionCounter.sessionsPerUser.hasOwnProperty(value)) {
        map.set(value, sessionCounter.sessionsPerUser[value]);
      }
    }
    return map;
  }

}
